var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8368 3.11667L10.5535 0.833337C10.2555 0.553417 9.86499 0.392803 9.45628 0.382047C9.04756 0.371291 8.64915 0.511145 8.33684 0.775004L0.836836 8.275C0.567474 8.54664 0.399756 8.90267 0.361836 9.28334L0.00350246 12.7583C-0.00772341 12.8804 0.0081144 13.0034 0.0498868 13.1187C0.0916592 13.2339 0.158338 13.3385 0.245169 13.425C0.323036 13.5022 0.415383 13.5633 0.516914 13.6048C0.618445 13.6463 0.727164 13.6673 0.836836 13.6667H0.911836L4.38684 13.35C4.7675 13.3121 5.12353 13.1444 5.39517 12.875L12.8952 5.375C13.1863 5.06748 13.3436 4.65709 13.3327 4.23378C13.3217 3.81047 13.1434 3.40876 12.8368 3.11667ZM4.23684 11.6833L1.73684 11.9167L1.96184 9.41667L6.67017 4.76667L8.92017 7.01667L4.23684 11.6833ZM10.0035 5.9L7.77017 3.66667L9.39517 2L11.6702 4.275L10.0035 5.9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.60e6913e49d94555a28e3e2445403718.svg";
export { ForwardRef as ReactComponent };